import { render, staticRenderFns } from "./brick_metavariables.vue?vue&type=template&id=8cb78a4a&"
import script from "./brick_metavariables.vue?vue&type=script&lang=js&"
export * from "./brick_metavariables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports